<app-social-button
  e2eId="connect-with-facebook"
  [icon]="facebookIcon"
  [disabled]="!(initialized$ | async) || (processing$ | async)"
  [isLoading]="processing$ | async"
  i2gTrackable
  [trackingObject]="trackingObject"
  [trackingAction]="trackingAction"
  [trackingAdditionalProperties]="trackingAdditionalProperties"
  (buttonClick)="signInToFacebook()"
>
</app-social-button>
